export default __webpack_public_path__ + "static/media/sms.66310d84.png";